import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/payments/ae.svg")